// assets/store-locator.js

let map;
let markers = [];
let infoWindow;
let currentStore = null;

function initStoreLocator() {
  console.log('Store Locator Initializing...');
  const data = window.storeLocatorData || {};
  
  // Initialize map
  map = new google.maps.Map(document.getElementById('storeMap'), {
    center: data.defaultCenter || { lat: 31.9686, lng: -99.9018 },
    zoom: data.defaultZoom || 6,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false,
    zoomControl: false,
    gestureHandling: "greedy",
    styles: [
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#A8D5E5" }]
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#F5F5F5" }]
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#FFFFFF" }]
      }
    ]
  });

  infoWindow = new google.maps.InfoWindow();
  console.log('Map initialized');

  // Add store markers
  if (data.stores && data.stores.length > 0) {
    console.log('Adding markers for', data.stores.length, 'stores');
    data.stores.forEach((store, index) => {
      if (store.lat && store.lng) {
        addMarker(store, index);
      }
    });
  }

  initEventListeners();
  initAccordion();
}

function addMarker(store, index) {
  const position = { lat: parseFloat(store.lat), lng: parseFloat(store.lng) };
  
  // Create custom marker
  const marker = new google.maps.Marker({
    position: position,
    map: map,
    title: store.name,
    animation: google.maps.Animation.DROP,
    icon: {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 40C20 40 35 25 35 15C35 6.71573 28.2843 0 20 0C11.7157 0 5 6.71573 5 15C5 25 20 40 20 40Z" fill="#1B4332"/>
          <circle cx="20" cy="15" r="6" fill="white"/>
        </svg>
      `),
      scaledSize: new google.maps.Size(40, 40),
      anchor: new google.maps.Point(20, 40)
    }
  });

  // Click event to show sidebar
  // marker.addListener('click', () => {
  //   console.log('Marker clicked:', store.name);
  //   showStoreSidebar(store);
  //   map.panTo(position);
    
  //   // Highlight corresponding accordion item
  //   highlightAccordionItem(store.storeId);
  // });

  marker.addListener('click', () => {

    // const content = `
    //   <div class="store-locator__info-window">
    //     <div class="info-window-card">
    //       <button class="info-window-close" onclick="infoWindow.close()">×</button>
    //       <div class="info-window-title">${store.fullName || store.name}</div>
    //       <div class="info-window-city">${store.city}, ${store.state}</div>
    //     </div>
    //   </div>
    // `;
    const content = `
      <div class="store-info-card">

          <div class="store-info-title">
            ${store.fullName || store.name}
          </div>

          <div class="store-info-address">
            ${store.address}
          </div>

          <div class="store-info-city">
            ${store.city}, ${store.state} ${store.zip}
          </div>

      </div>
    `;

    infoWindow.close();
    infoWindow.setContent(content);
    infoWindow.open(map, marker);

    showStoreSidebar(store);
    map.panTo(position);
    highlightAccordionItem(store.storeId);
  });


  markers.push({ marker, store, index });
}

function highlightAccordionItem(storeId) {
  // Remove active class from all items
  document.querySelectorAll('.store-locator__address-item').forEach(item => {
    item.classList.remove('active');
  });
  
  // Find and highlight the corresponding address item
  const addressItems = document.querySelectorAll('.store-locator__address-item');
  addressItems.forEach(item => {
    const itemIndex = parseInt(item.dataset.storeIndex);
    const store = window.storeLocatorData.stores[itemIndex];
    if (store && store.storeId === storeId) {
      item.classList.add('active');
      // Open the parent accordion
      const accordionItem = item.closest('.store-locator__accordion-item');
      const header = accordionItem.querySelector('.store-locator__accordion-header');
      const content = accordionItem.querySelector('.store-locator__accordion-content');
      
      header.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
      
      // Scroll to the item
      item.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });
}

function showStoreSidebar(store) {
  console.log('Showing sidebar for:', store.name);
  currentStore = store;
  const sidebar = document.getElementById('storeSidebar');
  
  // Populate sidebar data
  document.getElementById('sidebarStoreName').textContent = store.fullName || store.name;
  document.getElementById('sidebarStoreAddress').textContent = 
    `${store.address}, ${store.city}, ${store.state} ${store.zip}`;
  document.getElementById('sidebarStorePhone').textContent = store.phone || 'Contact for hours';
  document.getElementById('sidebarStoreImage').src = store.image;
  document.getElementById('sidebarStoreImage').alt = store.name;
  
  // Set directions link
  const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${store.address}, ${store.city}, ${store.state} ${store.zip}`
  )}`;
  document.getElementById('sidebarDirectionsBtn').href = directionsUrl;
  
  // Render product tags
  const tagsContainer = document.getElementById('sidebarProductTags');
  tagsContainer.innerHTML = '';
  
  if (store.tags && store.tags.length > 0) {
    store.tags.forEach(tag => {
      if (tag.trim()) {
        const tagEl = document.createElement('span');
        tagEl.className = 'store-locator__tag';
        tagEl.textContent = tag.trim();
        tagsContainer.appendChild(tagEl);
      }
    });
  }
  
  // Show sidebar with animation
  sidebar.classList.add('active');
  console.log('Sidebar activated');
  
  // Adjust map center to accommodate sidebar on desktop
  if (window.innerWidth > 768) {
    const sidebarWidth = 380;
    const offsetX = sidebarWidth / 2;
    map.panBy(-offsetX, 0);
  }
}

function hideStoreSidebar() {
  console.log('Hiding sidebar');
  const sidebar = document.getElementById('storeSidebar');
  sidebar.classList.remove('active');
  currentStore = null;
  
  // Remove active class from accordion items
  document.querySelectorAll('.store-locator__address-item').forEach(item => {
    item.classList.remove('active');
  });
  
  // Reset map center
  if (window.innerWidth > 768) {
    const sidebarWidth = 380;
    const offsetX = sidebarWidth / 2;
    map.panBy(offsetX, 0);
  }
}

function initAccordion() {
  const accordionHeaders = document.querySelectorAll('.store-locator__accordion-header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.parentElement;
      const content = item.querySelector('.store-locator__accordion-content');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all other accordion items
      accordionHeaders.forEach(otherHeader => {
        if (otherHeader !== this) {
          otherHeader.setAttribute('aria-expanded', 'false');
          otherHeader.parentElement.querySelector('.store-locator__accordion-content').style.maxHeight = null;
        }
      });
      
      // Toggle current item
      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        content.style.maxHeight = null;
      } else {
        this.setAttribute('aria-expanded', 'true');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
  
  // Address item click handlers
  const addressItems = document.querySelectorAll('.store-locator__address-item');
  addressItems.forEach(item => {
    item.addEventListener('click', function(e) {
      // Don't trigger if clicking the view button directly
      if (e.target.closest('.store-locator__address-view-btn')) return;
      
      const index = parseInt(this.dataset.storeIndex);
      const store = window.storeLocatorData.stores[index];
      
      if (store) {
        const position = { lat: parseFloat(store.lat), lng: parseFloat(store.lng) };
        map.setCenter(position);
        map.setZoom(15);
        showStoreSidebar(store);
        
        // Highlight marker
        markers.forEach(({ marker, store: markerStore }) => {
          if (markerStore.storeId === store.storeId) {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(() => marker.setAnimation(null), 2000);
          }
        });
        
        // Update active state
        addressItems.forEach(i => i.classList.remove('active'));
        this.classList.add('active');
      }
    });
    
    // View button click handler
    const viewBtn = item.querySelector('.store-locator__address-view-btn');
    if (viewBtn) {
      viewBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const index = parseInt(item.dataset.storeIndex);
        const store = window.storeLocatorData.stores[index];
        
        if (store) {
          const position = { lat: parseFloat(store.lat), lng: parseFloat(store.lng) };
          map.setCenter(position);
          map.setZoom(16);
          showStoreSidebar(store);
          
          // Highlight marker
          markers.forEach(({ marker, store: markerStore }) => {
            if (markerStore.storeId === store.storeId) {
              marker.setAnimation(google.maps.Animation.BOUNCE);
              setTimeout(() => marker.setAnimation(null), 2000);
            }
          });
          
          // Update active state
          addressItems.forEach(i => i.classList.remove('active'));
          item.classList.add('active');
        }
      });
    }
  });
}

function initEventListeners() {
  console.log('Initializing event listeners...');
  
  const searchTrigger = document.getElementById('searchTrigger');
  const modal = document.getElementById('searchModal');
  const closeModalBtn = document.getElementById('closeModal');
  const modalOverlay = modal.querySelector('.store-locator__modal-overlay');
  const modalInput = document.getElementById('modalSearchInput');
  const modalSearchBtn = document.getElementById('modalSearchBtn');
  const autocompleteResults = document.getElementById('autocompleteResults');
  const autocompleteList = document.getElementById('autocompleteList');
  const modalContent = modal.querySelector('.store-locator__modal-content');
  const zoomIn = document.getElementById('zoomIn');
  const zoomOut = document.getElementById('zoomOut');
  const closeSidebarBtn = document.getElementById('closeSidebar');

  // Open modal
  if (searchTrigger) {
    searchTrigger.addEventListener('click', (e) => {
      console.log('Search trigger clicked');
      e.preventDefault();
      e.stopPropagation();
      modal.classList.add('active');
      setTimeout(() => {
        if (modalInput) modalInput.focus();
      }, 100);
      document.body.style.overflow = 'hidden';
    });
  }

  // Close modal
  function closeModal() {
    console.log('Closing modal');
    modal.classList.remove('active');
    if (modalInput) modalInput.value = '';
    hideAutocomplete();
    document.body.style.overflow = '';
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });
  }
  
  if (modalOverlay) {
    modalOverlay.addEventListener('click', closeModal);
  }

  // Close sidebar
  if (closeSidebarBtn) {
    closeSidebarBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      hideStoreSidebar();
    });
  }

  // Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (modal.classList.contains('active')) {
        closeModal();
      } else if (document.getElementById('storeSidebar').classList.contains('active')) {
        hideStoreSidebar();
      }
    }
  });

  // Autocomplete
  let debounceTimer;
  if (modalInput) {
    modalInput.addEventListener('input', (e) => {
      console.log('Input changed:', e.target.value);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        filterLocations(e.target.value);
      }, 150);
    });
  }

  function filterLocations(query) {
    console.log('Filtering locations for:', query);
    if (!query || query.length < 1) {
      hideAutocomplete();
      return;
    }

    const cities = window.storeLocatorData.texasCities || [];
    const filtered = cities.filter(city => 
      city.toLowerCase().startsWith(query.toLowerCase())
    );

    if (filtered.length > 0) {
      showAutocomplete(filtered);
    } else {
      hideAutocomplete();
    }
  }

  function showAutocomplete(results) {
    console.log('Showing autocomplete results:', results);
    autocompleteList.innerHTML = '';
    
    results.forEach(result => {
      const li = document.createElement('li');
      li.className = 'store-locator__autocomplete-item';
      li.innerHTML = `
        <span class="store-locator__autocomplete-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </span>
        <span class="store-locator__autocomplete-text">${result}</span>
      `;
      li.addEventListener('click', () => {
        console.log('Autocomplete item clicked:', result);
        selectLocation(result);
      });
      autocompleteList.appendChild(li);
    });
    
    autocompleteResults.classList.add('active');
    modalContent.classList.add('has-autocomplete');
  }

  function hideAutocomplete() {
    autocompleteResults.classList.remove('active');
    modalContent.classList.remove('has-autocomplete');
  }

  function selectLocation(location) {
    console.log('Location selected:', location);
    modalInput.value = location;
    hideAutocomplete();
  }

  // Search functionality
  function performSearch(query) {
    console.log('Performing search for:', query);
    
    if (!query || query.trim() === '') {
      console.log('Empty query, returning');
      return;
    }
    
    query = query.trim();
    const data = window.storeLocatorData || {};
    const stores = data.stores || [];
    
    console.log('Searching through', stores.length, 'stores');
    
    // Try to find matching store first
    const matchingStore = stores.find(store => 
      store.city.toLowerCase().includes(query.toLowerCase()) ||
      store.zip.includes(query) ||
      store.name.toLowerCase().includes(query.toLowerCase()) ||
      store.address.toLowerCase().includes(query.toLowerCase())
    );

    if (matchingStore) {
      console.log('Found matching store:', matchingStore.name);
      const position = { 
        lat: parseFloat(matchingStore.lat), 
        lng: parseFloat(matchingStore.lng) 
      };
      
      map.setCenter(position);
      map.setZoom(14);
      showStoreSidebar(matchingStore);
      highlightAccordionItem(matchingStore.storeId);
      
      // Highlight marker
      markers.forEach(({ marker, store }) => {
        if (store.storeId === matchingStore.storeId) {
          marker.setAnimation(google.maps.Animation.BOUNCE);
          setTimeout(() => marker.setAnimation(null), 2000);
        }
      });
      
      closeModal();
      return;
    }

    console.log('No store match found, geocoding...');
    // Geocode search
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: query + ', Texas' }, (results, status) => {
      console.log('Geocode result:', status, results);
      if (status === 'OK' && results[0]) {
        const position = results[0].geometry.location;
        
        map.setCenter(position);
        map.setZoom(12);
        
        // Find nearest store
        findNearestStore(position);
        
        closeModal();
      } else {
        console.error('Geocode failed:', status);
        alert('Location not found. Please try again.');
      }
    });
  }

  function findNearestStore(position) {
    console.log('Finding nearest store to:', position);
    
    if (!google.maps.geometry || !google.maps.geometry.spherical) {
      console.error('Google Maps Geometry library not loaded.');
      const data = window.storeLocatorData || {};
      const stores = data.stores || [];
      if (stores.length > 0) {
        showStoreSidebar(stores[0]);
        highlightAccordionItem(stores[0].storeId);
      }
      return;
    }
    
    const data = window.storeLocatorData || {};
    const stores = data.stores || [];
    
    let nearestStore = null;
    let shortestDistance = Infinity;
    
    stores.forEach(store => {
      if (store.lat && store.lng) {
        const storePos = new google.maps.LatLng(parseFloat(store.lat), parseFloat(store.lng));
        const distance = google.maps.geometry.spherical.computeDistanceBetween(position, storePos);
        
        if (distance < shortestDistance) {
          shortestDistance = distance;
          nearestStore = store;
        }
      }
    });
    
    if (nearestStore) {
      console.log('Nearest store found:', nearestStore.name);
      showStoreSidebar(nearestStore);
      highlightAccordionItem(nearestStore.storeId);
    }
  }

  // Search button click handler
  if (modalSearchBtn) {
    console.log('Binding click event to search button');
    
    modalSearchBtn.replaceWith(modalSearchBtn.cloneNode(true));
    const freshSearchBtn = document.getElementById('modalSearchBtn');
    
    freshSearchBtn.addEventListener('click', function(e) {
      console.log('SEARCH BUTTON CLICKED!');
      e.preventDefault();
      e.stopPropagation();
      
      const inputVal = modalInput ? modalInput.value.trim() : '';
      console.log('Search input value:', inputVal);
      
      if (inputVal) {
        performSearch(inputVal);
      }
    });
    
    freshSearchBtn.addEventListener('touchend', function(e) {
      console.log('SEARCH BUTTON TOUCHED!');
      e.preventDefault();
      const inputVal = modalInput ? modalInput.value.trim() : '';
      if (inputVal) {
        performSearch(inputVal);
      }
    });
  }

  // Enter key on input
  if (modalInput) {
    modalInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        console.log('Enter key pressed in search input');
        e.preventDefault();
        const val = modalInput.value.trim();
        if (val) {
          performSearch(val);
        }
      }
    });
  }

  // Quick location chips
  document.querySelectorAll('.store-locator__chip').forEach((chip) => {
    chip.addEventListener('click', (e) => {
      const location = chip.dataset.location;
      const lat = parseFloat(chip.dataset.lat);
      const lng = parseFloat(chip.dataset.lng);
      
      if (lat && lng) {
        map.setCenter({ lat, lng });
        map.setZoom(12);
        performSearch(location);
      }
    });
  });

  // Popular location chips
  document.querySelectorAll('.store-locator__popular-chip').forEach((chip) => {
    chip.addEventListener('click', (e) => {
      const location = chip.dataset.location;
      if (modalInput) {
        modalInput.value = location;
      }
      performSearch(location);
    });
  });

  // Zoom controls
  if (zoomIn) {
    zoomIn.addEventListener('click', () => {
      console.log('Zoom in clicked');
      map.setZoom(map.getZoom() + 1);
    });
  }
  
  if (zoomOut) {
    zoomOut.addEventListener('click', () => {
      console.log('Zoom out clicked');
      map.setZoom(map.getZoom() - 1);
    });
  }

  // Save store button
  const saveStoreBtn = document.getElementById('saveStoreBtn');
  if (saveStoreBtn) {
    saveStoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Save button clicked');
      
      if (currentStore) {
        this.classList.toggle('saved');
        const isSaved = this.classList.contains('saved');
        
        this.innerHTML = isSaved ? 
          `<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
          </svg> Saved` :
          `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
          </svg> Save`;
        
        console.log('Store saved state:', isSaved, currentStore.name);
      }
    });
  }

  console.log('Event listeners initialized successfully');
}

// Marker bounce animation CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes markerBounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
  }
  
  .store-locator__btn.saved {
    background: #E8F5E9;
    color: #2E7D32;
    border-color: #2E7D32;
  }
`;
document.head.appendChild(style);

console.log('Store Locator JS file loaded');